import { useState, useEffect } from "react";
import { FiX } from "react-icons/fi";
import "../AcquisitionPopup.css";

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

function safeStorageGet(key) {
  try { return localStorage.getItem(key); } catch { return null; }
}

function safeStorageSet(key, value) {
  try { localStorage.setItem(key, value); } catch { /* best-effort */ }
}

export default function AcquisitionPopup({ popup, brandKey }) {
  const [show, setShow] = useState(false);
  const storageKey = `${brandKey || "brand"}_popup_closed_at`;

  useEffect(() => {
    if (!popup) return;
    const raw = safeStorageGet(storageKey);
    const ts = parseInt(raw, 10);
    if (!ts || Date.now() - ts > ONE_DAY_MS) {
      setShow(true);
    }
  }, [popup, storageKey]);

  if (!popup || !show) return null;

  const handleClose = () => {
    safeStorageSet(storageKey, Date.now().toString());
    setShow(false);
  };

  const handleImgError = (e) => {
    e.target.style.display = 'none';
  };

  return (
    <div className={`cabana-popup ${show ? "show" : "hide"}`}>
      <div className="cabana-popup-content">
        <div className="cabana-popup-close" aria-label="Close" onClick={handleClose}>
          <FiX size={24} />
        </div>

        <div className="cabana-popup-title">
          {popup.brandName} is now a part of Cabana!
        </div>
        <div className="cabana-popup-subtitle">
          Same great techs, same great service, just under a new brand. Please
          kindly note that communications you receive will come from Cabana.
        </div>

        <div className="cabana-img-wrap">
          <div className="cabana-imgs">
            <img src="/images/brands/cabana-logo.svg" alt="Cabana logo" onError={handleImgError} />
          </div>
          <div className="cabana-imgs">
            <img src={popup.brandLogo} alt={`${popup.brandName} logo`} onError={handleImgError} />
          </div>
          <div className="cabana-pluse-img">
            <img src="/images/brands/plus-vector.svg" alt="plus" onError={handleImgError} />
          </div>
        </div>

        <div className="cabana-footer">
          <button className="btn setp-next-btn w-full" onClick={handleClose}>
            GOT IT!
          </button>
        </div>
      </div>
    </div>
  );
}
